<hlm-popover
  class="w-full"
  align="start"
  [state]="overlayState()"
  (stateChanged)="onStateChanged($event)"
>
  <button
    #trigger
    type="button"
    hlmPopoverTrigger
    class="priority-dropdown__trigger"
    [class.priority-dropdown__trigger--high]="selectedModifier() === 'high'"
    [class.priority-dropdown__trigger--medium]="selectedModifier() === 'medium'"
    [class.priority-dropdown__trigger--low]="selectedModifier() === 'low'"
    aria-haspopup="listbox"
    [attr.aria-expanded]="isOpen()"
    (click)="onTriggerClick()"
    (keydown.space)="$event.preventDefault()"
  >
    @if (ariaLabel()) {
      <span class="visually-hidden">{{ ariaLabel() }}</span>
    }
    <span class="priority-dropdown__dot"></span>
    <span class="priority-dropdown__label">
      @if (selectedOption(); as option) {
        {{ option.labelKey | translate }}
      } @else {
        {{ placeholder() || ('priority-dropdown.not-set' | translate) }}
      }
    </span>
    <ocp-themed-icon
      class="priority-dropdown__chevron"
      [name]="chevronIcon()"
      [size]="chevronSize()"
    />
  </button>

  <hlm-popover-content *hlmPopoverPortal class="w-fit p-2.5" [style.min-width]="triggerWidth()">
    <div
      class="priority-dropdown__list"
      role="listbox"
      [attr.aria-activedescendant]="activeDescendant()"
      [attr.aria-label]="ariaLabel()"
    >
      @for (option of options; track trackByValue($index, option); let i = $index) {
        <div
          [id]="getOptionId(i)"
          role="option"
          class="priority-dropdown__option"
          [class.priority-dropdown__option--high]="option.modifier === 'high'"
          [class.priority-dropdown__option--medium]="option.modifier === 'medium'"
          [class.priority-dropdown__option--low]="option.modifier === 'low'"
          [class.priority-dropdown__option--selected]="isSelected(option)"
          [class.priority-dropdown__option--focused]="focusedIndex() === i"
          [attr.aria-selected]="isSelected(option)"
          [attr.tabindex]="focusedIndex() === i ? 0 : -1"
          (click)="selectOption(option, $event)"
          (keydown)="onOptionKeydown($event, option, i)"
        >
          <span class="priority-dropdown__checkmark-space">
            @if (isSelected(option)) {
              <ocp-themed-icon
                class="priority-dropdown__checkmark"
                name="checkmark.svg"
                [size]="16"
              />
            }
          </span>
          <span class="priority-dropdown__option-dot"></span>
          <span class="priority-dropdown__option-label">{{ option.labelKey | translate }}</span>
        </div>
      }
    </div>
  </hlm-popover-content>
</hlm-popover>
